import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
// eslint-disable-next-line no-unused-vars
import Car from './Car'
import CreditRisk from './CreditRisk'

export default function Dashboard({ match }) {
  return (
    <div className="content">
      <div className="container-fluid">
        <Route path={`${match.url}/car`} component={Car} />
        <Route path={`${match.url}/credit-risk`} component={CreditRisk} />
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/pages/Dashboard/index.js